import { PUBLIC_URL } from '../../utils/constants';

export default {
  ARTICLE_DASHBOARD: `${PUBLIC_URL}/article/dashboard`,
};
